// Client V2 common imports
const userActions = require('client-v2/common/models/user/actions')

function wrapUserAction(actionKey) {
  return function (options) {
    const wrappedOptions = Object.assign({
      user: options.profileUser
    }, options)
    return userActions[actionKey](wrappedOptions)
  }
}

module.exports = {}

// Define wrapped user actions
Array.of(
  'navigateToUserProfile',
  'navigateToUserProfileCollections',
  'navigateToUserProfileCollectionsCreated',
  'navigateToUserProfileCollectionsSubscribed',
  'navigateToUserProfileFollowers',
  'navigateToUserProfileFollowing',
  'navigateToUserProfilePosts',
  'showUserActionsModal',
  'showUserShareModal',
  'toggleFollowing'
).forEach(userAction => {
  module.exports[userAction] = wrapUserAction(userAction)
})
